<template>
  <div class="min-h-screen p-4 bg-gray-200 dark:bg-gray-900">
    <!-- Modals -->
    <addModal @refresh="getAllInventory" />
    <editModal @refresh="getAllInventory" :inventory="selectedInventory" />
    <transferModal @refresh="getAllInventory" :inventory="selectedInventory" />
    <!-- New Transfer Modal -->
    <newTransferModal :inventory="selectedInventory" @refresh="onTransferComplete" />
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <!-- Header -->
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h1 class="text-2xl font-bold text-gray-800 dark:text-white">
            <i class="fas fa-boxes mr-2"></i>
            Envanter Yönetimi
          </h1>
          <div class="flex space-x-2">
            <button
              @click="exportToExcel"
              class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <i class="fas fa-file-excel mr-2"></i>
              Excel'e Aktar
            </button>
            <button
              @click="$modal.show('add-inventory-modal')"
              class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              <i class="fas fa-plus mr-2"></i>
              Yeni Envanter
            </button>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Arama
            </label>
            <div class="relative">
              <input
                v-model="filters.search"
                @keyup.enter="handleSearch"
                type="text"
                placeholder="Ürün adı, kod, seri no veya plaka..."
                class="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <i class="fas fa-search text-gray-400" title="Enter tuşuna basarak arama yapın"></i>
              </div>
            </div>
            <p class="text-xs text-gray-500 mt-1">
              <i class="fas fa-info-circle mr-1"></i>
              Enter tuşuna basarak arama yapın
            </p>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Kategori
            </label>
            <select
              v-model="filters.category"
              @change="getAllInventory"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Tümü</option>
              <option value="POMPA&HORTUM&DUSURUCU">Pompa & Hortum & Düşürücü</option>
              <option value="GUVENLIK">Güvenlik Ekipmanı</option>
              <option value="YEDEK_PARCA">Yedek Parça</option>
              <option value="DIGER">Diğer</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Konum
            </label>
            <select
              v-model="filters.location"
              @change="getAllInventory"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Tümü</option>
              <option value="BOSTA">Boşta</option>
              <option value="ARACTA">Araçta</option>
              <option value="SUBEDE">Şubede</option>
              <option value="TRANSFERDE">Transferde</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Durum
            </label>
            <select
              v-model="filters.status"
              @change="getAllInventory"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Tümü</option>
              <option value="AKTIF">Aktif</option>
              <option value="PASIF">Pasif</option>
              <option value="BAKIM">Bakımda</option>
              <option value="ARIZALI">Arızalı</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-700">
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Ürün Kodu
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Ürün Adı
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Kategori
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Seri No
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Konum
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Durum
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                İşlemler
              </th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-if="loading">
              <td colspan="7" class="text-center py-12">
                <div class="flex justify-center items-center">
                  <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
              </td>
            </tr>
            <tr v-else-if="inventoryList.length === 0">
              <td colspan="7" class="text-center py-12 text-gray-500">
                Envanter bulunamadı
              </td>
            </tr>
            <tr v-else v-for="item in inventoryList" :key="item.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                {{ item.product_code }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                {{ item.name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                <span class="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                  {{ getCategoryLabel(item.category) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                {{ item.serial_number || '-' }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm">
                <div>
                  <span :class="getLocationClass(item.current_location)">
                    {{ getLocationLabel(item.current_location) }}
                  </span>
                  <span v-if="item.vehicle_plate" class="ml-2 text-xs text-gray-600">
                    ({{ item.vehicle_plate }})
                  </span>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm">
                <span :class="getStatusClass(item.status)">
                  {{ getStatusLabel(item.status) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div class="flex space-x-2">
                  <button
                    @click="editInventory(item)"
                    class="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center space-x-1"
                    title="Envanter bilgilerini düzenle"
                  >
                    <i class="fas fa-edit"></i>
                    <span>Düzenle</span>
                  </button>
                  <button
                    @click="transferInventory(item)"
                    class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 transition-colors flex items-center space-x-1"
                    title="Transfer geçmişini görüntüle"
                  >
                    <i class="fas fa-history"></i>
                    <span>Geçmiş</span>
                  </button>
                  <button
                    @click="openNewTransferModal(item)"
                    class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 transition-colors flex items-center"
                  >
                    <i class="fas fa-plus mr-2"></i>
                    Yeni Transfer
                  </button>
                  <button
                    @click="deleteInventory(item)"
                    class="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors flex items-center space-x-1"
                    title="Envanteri sil"
                  >
                    <i class="fas fa-trash"></i>
                    <span>Sil</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="pagination.pages > 1" class="p-6 border-t border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <div class="text-sm text-gray-700 dark:text-gray-300">
            Toplam {{ pagination.total }} kayıttan {{ (pagination.page - 1) * pagination.limit + 1 }} -
            {{ Math.min(pagination.page * pagination.limit, pagination.total) }} arası gösteriliyor
          </div>
          <div class="flex space-x-2">
            <button
              v-for="page in visiblePages"
              :key="page"
              @click="changePage(page)"
              :class="[
                'px-3 py-1 rounded',
                page === pagination.page
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              ]"
            >
              {{ page }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { inventory } from '../../../networking/urlmanager';
import addModal from './components/addModal.vue';
import editModal from './components/editModal.vue';
import transferModal from './components/transferModal.vue';
import newTransferModal from './components/newTransferModal.vue';
import * as XLSX from 'xlsx';
export default {
  name: 'InventoryManagement',
  components: {
    addModal,
    editModal,
    transferModal,
    newTransferModal
  },
  data() {
    return {
      inventoryList: [],
      loading: false,
       error: null,
      transferHistory: [],
      selectedInventory: null,
      filters: {
        search: '',
        category: '',
        location: '',
        status: ''
      },
      pagination: {
        page: 0,  // Backend 0'dan başlıyor
        limit: 20,
        total: 0,
        pages: 0
      }
    };
  },
  computed: {
    visiblePages() {
      const pages = [];
      const currentPage = this.pagination.page + 1; // Display için 1'den başlat
      const start = Math.max(1, currentPage - 2);
      const end = Math.min(this.pagination.pages, currentPage + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  mounted() {
    this.getAllInventory();
  },
  methods: {
     async fetchTransferHistory() {
      if (!this.inventory || !this.inventory.id) return;

      this.loading = true;
      this.error = null;

      try {
        const response = await axios.get(inventory.transferHistory, {
          params: {
            inventoryId: this.inventory.id,
            page: this.pagination.page,
            limit: this.pagination.limit
          },
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.transferHistory = response.data.data.detail || [];
          this.pagination = {
            total: response.data.data.totalCount,
            pages: response.data.data.pageCount,
            page: this.pagination.page,
            limit: this.pagination.limit
          };
        }
      } catch (error) {
        console.error('Error fetching transfer history:', error);
        this.error = error.response?.data?.message || 'Transfer geçmişi alınırken hata oluştu';
      } finally {
        this.loading = false;
      }
    },
    onTransferComplete() {
      // Transfer tamamlandığında geçmişi yenile
      this.fetchTransferHistory();
      // Ana inventory listesini de yenile
      this.$emit('refresh');
    },
    openNewTransferModal(item) {
      this.selectedInventory = item;
      this.$modal.show('new-transfer-modal');
    },
    async getAllInventory() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.filters
        };

        const response = await axios.get(inventory.getAll, {
          params,
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.inventoryList = response.data.data.detail || [];
          this.pagination = {
            total: response.data.data.totalCount,
            pages: response.data.data.pageCount,
            page: this.pagination.page,
            limit: this.pagination.limit
          };
        }
      } catch (error) {
        console.error('Error fetching inventory:', error);
        this.$toast.error('Envanter listesi alınırken hata oluştu');
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      // Sayfa numarasını sıfırla ve arama yap
      this.pagination.page = 0;
      this.getAllInventory();
    },

    changePage(displayPage) {
      this.pagination.page = displayPage - 1; // Backend için 0-indexed
      this.getAllInventory();
    },

    editInventory(item) {
      this.selectedInventory = item;
      setTimeout(() => {
        this.$modal.show('edit-inventory-modal');
      }, 100);
    },

    transferInventory(item) {
      this.selectedInventory = item;
      this.$modal.show('transfer-inventory-modal');
    },

    async deleteInventory(item) {
      const confirmed = await this.$swal({
        title: 'Emin misiniz?',
        text: `"${item.name}" envanteri silinecek`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Sil',
        cancelButtonText: 'İptal'
      });

      if (confirmed.isConfirmed) {
        try {
          const response = await axios.post(inventory.delete,
            { id: item.id },
            {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              }
            }
          );

          if (response.data.code === 200) {
            this.$toast.success('Envanter başarıyla silindi');
            this.getAllInventory();
          }
        } catch (error) {
          console.error('Error deleting inventory:', error);
          this.$toast.error(error.response?.data?.message || 'Silme işlemi başarısız');
        }
      }
    },

    getCategoryLabel(category) {
      const labels = {
        'POMPA&HORTUM&DUSURUCU': 'Pompa & Hortum & Düşürücü',
        'GUVENLIK': 'Güvenlik Ekipmanı',
        'YEDEK_PARCA': 'Yedek Parça',
        'DIGER': 'Diğer'
      };
      return labels[category] || category;
    },

    getLocationLabel(location) {
      const labels = {
        'BOSTA': 'Boşta',
        'ARACTA': 'Araçta',
        'GARAJDA': 'Şubede',
        'SUBEDE': 'Şubede',
        'TRANSFERDE': 'Transferde'
      };
      return labels[location] || location;
    },

    getLocationClass(location) {
      const classes = {
        'BOSTA': 'px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800',
        'ARACTA': 'px-2 py-1 text-xs rounded-full bg-green-100 text-green-800',
        'GARAJDA': 'px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800',
        'SUBEDE': 'px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800',
        'TRANSFERDE': 'px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800'
      };
      return classes[location] || 'px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800';
    },

    getStatusLabel(status) {
      const labels = {
        'AKTIF': 'Aktif',
        'PASIF': 'Pasif',
        'BAKIM': 'Bakımda',
        'ARIZALI': 'Arızalı'
      };
      return labels[status] || status;
    },

    getStatusClass(status) {
      const classes = {
        'AKTIF': 'px-2 py-1 text-xs rounded-full bg-green-100 text-green-800',
        'PASIF': 'px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800',
        'BAKIM': 'px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800',
        'ARIZALI': 'px-2 py-1 text-xs rounded-full bg-red-100 text-red-800'
      };
      return classes[status] || 'px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800';
    },

    exportToExcel() {
      try {
        // Excel için veriyi hazırla
        const excelData = this.inventoryList.map(item => ({
          'Ürün Kodu': item.product_code || '',
          'Ürün Adı': item.name || '',
          'Kategori': this.getCategoryLabel(item.category),
          'Seri No': item.serial_number || '',
          'Konum': this.getLocationLabel(item.current_location) + (item.vehicle_plate ? ` (${item.vehicle_plate})` : ''),
          'Durum': this.getStatusLabel(item.status)
        }));

        // Worksheet oluştur
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Sütun genişliklerini ayarla
        const columnWidths = [
          { wch: 15 }, // Ürün Kodu
          { wch: 30 }, // Ürün Adı
          { wch: 25 }, // Kategori
          { wch: 20 }, // Seri No
          { wch: 25 }, // Konum
          { wch: 15 }  // Durum
        ];
        worksheet['!cols'] = columnWidths;

        // Workbook oluştur
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

        // Dosya adını tarih ile oluştur
        const date = new Date();
        const fileName = `Envanter_${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}.xlsx`;

        // Excel dosyasını indir
        XLSX.writeFile(workbook, fileName);

        this.$toast.success('Excel dosyası başarıyla indirildi');
      } catch (error) {
        console.error('Excel export error:', error);
        this.$toast.error('Excel dosyası oluşturulurken hata oluştu');
      }
    }
  },

  watch: {
    inventory: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.pagination.page = 0;
          this.fetchTransferHistory();
        }
      }
    },
  },
};
</script>